module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/student-blue-6d5c295efb54b636698090d5f0982b16.svg";